<p-confirmDialog key="Edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="EditConfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main School Details-->
<div class="MainForm">
	<label>SchoolID:</label>
	<input class="form-control" disabled type="text" [(ngModel)]="SchoolID" />

	<label>School Name:</label>
	<input class="form-control" type="text" [(ngModel)]="SchoolName" />

	<label>School Number:</label>
	<input class="form-control" [disabled]="IsSuperUser() == false" type="text" [(ngModel)]="SchoolNumber" />

	<label>Phone:</label>
	<input class="form-control" type="text" [(ngModel)]="Phone" />

	<label>Address:</label>
	<input class="form-control" type="text" [(ngModel)]="Street" />

	<label>City:</label>
	<input class="form-control" type="text" [(ngModel)]="City" />

	<label>State:</label>
	<input class="form-control" type="text" [(ngModel)]="State" />

	<label>Zip:</label>
	<input class="form-control" type="text" [(ngModel)]="Zip" />

	<label>School Type:</label>
	<select class="form-control" name="SchoolTypeID" [(ngModel)]="SchoolTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstSchoolTypes" [ngValue]="o.SchoolTypeID">
			{{ o.SchoolTypeDesc }}
		</option>
	</select>
</div>

<!--Facilities-->
<div class="SecondaryForm">
	<caass-facility-assign [SchoolIDFromMain]="SchoolID"></caass-facility-assign>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
